var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),_c('transition',{attrs:{"name":"slide-up"}},[_c('div',[(_vm.selectedMesh.id && !_vm.selectedMesh.name.includes('ACC_'))?_c('texture-transform-selectors'):_vm._e()],1)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }